export default {
  staticSegmentTooltip: 'Segment once created will continue to have same set of outlets throughout unless segment rules are changed',
  dynamicSegmentTooltip: 'Segment will refresh outlets based on selected frequency and applicability will get refreshed periodically',
  refreshDailyTooltip: 'Segment will refresh outlet list daily',
  refreshWeeklyTooltip: 'Segment will refresh outlet list every Monday',
  refreshMonthlyTooltip: 'Segment will refresh outlet list on the 1st date of every calendar month',
};
